export class BreadcrumbTabsComponentController {

    public links: string[] = [];

    constructor(private $window: ng.IWindowService) {
    }


}
